export type AttachmentEmbedRenderGuardInput = {
  blobUrl: string;
  interactive: boolean;
  refreshKey: string | null;
  rerenderOnContextChange: boolean;
  selected: boolean;
};

export function getAttachmentEmbedRenderGuardValues({
  blobUrl,
  interactive,
  refreshKey,
  rerenderOnContextChange,
  selected,
}: AttachmentEmbedRenderGuardInput) {
  if (!rerenderOnContextChange) {
    return [refreshKey, blobUrl];
  }

  return [refreshKey, blobUrl, interactive, selected];
}
